import Btn from "../components/btn/landing-page/Btn";
import Slider from "../components/slider/Slider";
import PagePadding from "../layouts/PagePadding";
import storyOne from "../assets/storyOne.png";
import storyTwo from "../assets/storyTwo.png";
import storyThree from "../assets/storyThree.png";
import storyFour from "../assets/storyFour.png";
import trendingOne from "../assets/trendingOne.png";
import trendingTwo from "../assets/trendingTwo.png";
import trendingThree from "../assets/trendingThree.png";
import trendingFour from "../assets/trendingFour.png";
import trendingFive from "../assets/trendingFive.png";
import trendingSix from "../assets/trendingSix.png";
import trendingSeven from "../assets/trendingSeven.png";
import trendingEight from "../assets/trendingEight.png";
import stepOne from "../assets/stepOne.png";
import stepTwo from "../assets/stepTwo.png";
import stepThree from "../assets/stepThree.png";
import community from "../assets/community.png";
import { Link } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const LandingPage = () => {
  const { user } = useAuth();
  return (
    <div className="bg-neutral-200 min-h-screen">
      <section className="">
        <Slider />
      </section>

      <section className="h-auto xl:h-screen bg-white">
        <PagePadding>
          <div className="h-auto xl:h-screen flex flex-col lg:flex-row">
            <div className="w-full  lg:w-38% flex h-auto lg:h-screen items-center">
              <div className="mt-24 lg:mt-0">
                <h1 className="font-bold text-3xl">Tell Your Story</h1>
                <p className="font-normal text-lg mt-3 mr-5 lg:mr-20">
                  Join our vibrant community of buyers and sellers and find what
                  defines your style
                </p>
                <div className="w-1/2 lg:w-full mt-3 md:mt-12">
                  {user.data ? (
                    <div className="w-auto md:w-3/4 lg:w-full">
                      <Btn bg="bg-black" innerText="Explore Communities" />
                    </div>
                  ) : (
                    <Link to="/sign-up">
                      <Btn
                        innerText="Get Started"
                        bg="bg-red-800"
                        link="/sign-up"
                      />
                    </Link>
                  )}
                </div>
              </div>
            </div>
            <div className="w-full lg:w-62% flex gap-3 mt-12 lg:mt-0">
              <div className="flex flex-col gap-3">
                <img
                  src={storyOne}
                  alt="user story"
                  className="w-full h-3/4 object-cover"
                />
                <img
                  src={storyThree}
                  alt="user story"
                  className="w-full h-storyThree object-cover"
                />
              </div>

              <div className="flex flex-col gap-3">
                <img
                  src={storyTwo}
                  alt="user story"
                  className="h-1/2 w-full object-cover"
                />
                <img
                  src={storyFour}
                  alt="user story"
                  className="h-1/2 w-full object-cover"
                />
              </div>
            </div>
          </div>
        </PagePadding>
      </section>

      <section className="h-auto xl:h-screen mt-10">
        <PagePadding>
          <h1 className="text-center text-2xl font-bold">
            Trending on Thrifit
          </h1>
          <div className="flex flex-col gap-3">
            <div className="mt-10 overflow-scroll scrollbar-none">
              <div className="flex gap-3">
                <img
                  src={trendingOne}
                  alt="trending on thrifit"
                  className="object-cover"
                />
                <img
                  src={trendingTwo}
                  alt="trending on thrifit"
                  className="object-cover"
                />
                <img
                  src={trendingThree}
                  alt="trending on thrifit"
                  className="object-cover"
                />
                <img
                  src={trendingFour}
                  alt="trending on thrifit"
                  className="object-cover"
                />
                <img
                  src={trendingFive}
                  alt="trending on thrifit"
                  className="object-cover"
                />
              </div>
            </div>
            <div className="overflow-scroll scrollbar-none">
              <div className="flex gap-3">
                <img
                  src={trendingSix}
                  alt="trending on thrifit"
                  className="object-cover"
                />
                <img
                  src={trendingSeven}
                  alt="trending on thrifit"
                  className="object-cover"
                />
                <img
                  src={trendingEight}
                  alt="trending on thrifit"
                  className="object-cover"
                />
              </div>
            </div>
          </div>
        </PagePadding>
      </section>

      <section className="h-auto  mt-5 pb-5 bg-black">
        <div className="h-full">
          <h1 className="text-4xl text-center pt-8 text-white font-bold">
            Sell in 3 easy steps
          </h1>
          <PagePadding>
            <div className="flex flex-col lg:flex-row h-full mt-3 lg:mt-5 gap-3">
              <div className="mt-8 lg:mt-0">
                <img
                  src={stepOne}
                  alt="steps"
                  className="w-full lg:w-auto object-cover"
                />
                <div className="text-white">
                  <h5 className="text-2xl font-normal mt-2">
                    Create an account
                  </h5>
                  <p className="font-normal text-base mt-2">
                    Save the planet one item at a time
                  </p>
                </div>
              </div>
              <div className="mt-8 lg:mt-0">
                <img
                  src={stepTwo}
                  alt="steps"
                  className="w-full lg:w-auto object-cover"
                />
                <div className="text-white">
                  <h5 className="text-2xl font-normal mt-2">List It</h5>
                  <p className="font-normal text-base mt-2">
                    Upload high quality images, show your unique style
                  </p>
                </div>
              </div>
              <div className="mt-8 lg:mt-0">
                <img
                  src={stepThree}
                  alt="steps"
                  className="w-full lg:w-auto object-cover"
                />
                <div className="text-white">
                  <h5 className="text-2xl font-normal mt-2">Thrift It</h5>
                  <p className="font-normal text-base mt-2">
                    Build your community, make money while making an impact
                  </p>
                </div>
              </div>
            </div>
          </PagePadding>
          <div className="text-white cursor-pointer md:pb-36">
            <div className="flex justify-center items-center rounded-3xl gap-3 mt-10 w-3/5 h-12 md:w-226 m-auto bg-communityBtn">
              <div className="flex">
                <img src={community} alt="community" />
                <img src={community} alt="community" />
              </div>

              <div>Join the community</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
